// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css'; // 默认主题
import 'bootstrap/dist/css/bootstrap.min.css';
import 'vue-easytable/libs/themes-base/index.css';
import 'flatpickr/dist/flatpickr.css';
import App from './App';
import router from './router';
import store from './store';
// import axios from 'axios';
import VCharts from 'v-charts';
import {
  VTable,
  VPagination
} from 'vue-easytable';
import flatPickr from 'vue-flatpickr-component';
import $ from 'jquery';
import '../static/plugins/jQuery/jQuery-2.1.4.min';
import 'bootstrap/dist/js/bootstrap.min.js';
import '../static/plugins/zTree/jquery.ztree.all-3.5.min';
import '../static/plugins/zTree/jquery.ztree.excheck-3.5.min';
import './components/common/Validate.js';
import './components/common/common.js';
import './components/common/axios.js';
import '../static/js/app.js';
import 'babel-polyfill';

Vue.use(ElementUI);
Vue.use(flatPickr);
Vue.use(VCharts);

Vue.config.productionTip = false;
// Vue.prototype.$http = axios;
// axios.defaults.baseURL = process.env.API;
// Vue.prototype.HOST = '/api';
// 将组件注册到全局
Vue.component(VTable.name, VTable);
Vue.component(VPagination.name, VPagination);

// 路由守卫
router.beforeEach((to, from, next) => {

  var _hmt = _hmt || [];
  (function () {
    console.log('luyou执行统计')
    var hm = document.createElement("script");
    hm.src = "https://hm.baidu.com/hm.js?8fb730cd77a43242e45392edd52e4823";
    var s = document.getElementsByTagName("script")[0];
    s.parentNode.insertBefore(hm, s);
  })();

  let isLogin = localStorage.getItem('isLogin');
  if (to.path === '/login' && isLogin) {
    next({
      path: '/home'
    });
  }

  if (to.meta.check) {
    let check = async function () {
      const result = await checkUser();
      if (result.status === 0) {
        next();
      } else {
        // 用户未登录
        next({
          path: '/login'
        });
      }
    };
    check(); //后台验证session
  } else {
    next();
  }
});


/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: {
    App
  }
});



// WEBPACK FOOTER //
// ./src/main.js